<button mat-raised-button color="primary" type="button" (click)="buttonAction('MAIN')" class="split-button-left" [disabled]="buttonsData.buttonLoading">
	<div class="d-flex align-items-center">
		@if(buttonsData.buttonLoading) {
		<mat-spinner class="me-2" diameter="16"></mat-spinner>
		}
		<span>{{ buttonsData.buttonLabel| translate }}</span>
	</div>
</button>
<button mat-raised-button color="primary" type="button" class="split-button-right" (click)="buttonAction('SECONDARY')" [disabled]="buttonsData.buttonLoading">
	<mat-icon aria-hidden="false" aria-label="Suffix button">{{ buttonsData.buttonIcon }}</mat-icon>
</button>
